module.exports = __webpack_public_path__ + "static/media/5H.a746d66d.svg";